import React from 'react';
import CSVImporterAddShopifyTag from '../CSVImporterAddShopifyTag';

const AddShopifyTags = () => {
  return (
    <div>
      <h2 className="header">Add Shopify Tag</h2>
      <div style={{ textAlign: 'center' }}>
        <CSVImporterAddShopifyTag />
      </div>
    </div>
  );
};

export default AddShopifyTags;
